var ToastDuration;

(function (ToastDuration) {
  ToastDuration[ToastDuration["Short"] = 4000] = "Short";
  ToastDuration[ToastDuration["Medium"] = 6000] = "Medium";
  ToastDuration[ToastDuration["Long"] = 10000] = "Long";
})(ToastDuration || (ToastDuration = {}));

export { ToastDuration };
